// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__17BUs","title":"ClientInsurance_title__1FHUP","itemText":"ClientInsurance_itemText__zlaEQ"};